import type { CSSProperties } from "react"

import {
  dataByDetectionClass,
  type DetectionClass,
} from "@/constants/terminal/detection-class"

// The coloured pill: a detection's type, in its class's colour. One pill for
// the detection card and a table's Detections column alike. Given a class it
// colours itself; without one it takes the colour its lane or card sets
// (--terminal-detection-color).
export const DetectionPill = ({
  label,
  detectionClass,
}: {
  label: string
  detectionClass?: DetectionClass
}) => (
  <span
    className="terminal-detection-finding-pill type-micro inline-flex items-center whitespace-nowrap"
    style={
      detectionClass
        ? ({
            "--terminal-detection-color":
              dataByDetectionClass[detectionClass].color,
          } as CSSProperties)
        : undefined
    }
  >
    {label}
  </span>
)
